import { httpClient } from '@bcba/client-auth';

export const requestApprovalProductiveFacility = async (
  facilityUuid: string,
) => {
  return httpClient.patch(
    `/productive-facilities/${facilityUuid}/request-approval`,
  );
};
